(() => {
  const initialize = async () => {
    const reminders = document.querySelectorAll('[data-kbd-sold-reminder]');
    await Promise.all(Array.from(reminders).map(async (container) => {
      const productId = container.dataset.productId;
      if (!productId) return;
      try {
        const response = await fetch(`/apps/kbd-notify/sold?productId=${encodeURIComponent(productId)}`, { headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok || !data.enabled) return;
        const details = container.closest('.product-detail__detail, .kbd-product-panel') || container.parentElement;
        if (data.position === 'below-price') {
          const price = details?.querySelector('.product-detail__price, .kbd-price');
          if (price) price.insertAdjacentElement('afterend', container);
        } else if (data.position === 'above-buy-button') {
          const form = details?.querySelector('form[id^="product-form-"]:not([id$="-installments"]), .kbd-form');
          if (form) form.insertAdjacentElement('beforebegin', container);
        }
        const sold = container.querySelector('[data-kbd-sold-text]');
        const progress = container.querySelector('[data-kbd-sold-progress]');
        const bar = container.querySelector('[data-kbd-sold-bar]');
        const goal = container.querySelector('[data-kbd-sold-goal]');
        if (sold) sold.textContent = data.soldText;
        if (goal) goal.textContent = data.goalText;
        if (progress) {
          progress.hidden = !data.showProgress;
          progress.setAttribute('aria-valuenow', String(data.percent));
          progress.setAttribute('aria-label', data.goalText);
          progress.style.setProperty('--kbd-sold-track', data.trackColor);
        }
        if (bar) {
          bar.style.setProperty('--kbd-sold-percent', `${data.percent}%`);
          bar.style.setProperty('--kbd-sold-color', data.barColor);
        }
        if (goal) goal.hidden = !data.showGoal;
        container.hidden = false;
      } catch {
        container.hidden = true;
      }
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
